export const onlyLettersRegExp = new RegExp(/^[а-яА-ЯЁё ]{0,255}$/);
export const slugRegExp = new RegExp(/^[a-zA-Z0-9-_]+$/);
export const textbookNameRegExp = new RegExp(/^.{0,1000}$/);
export const phoneNumberRegExp = new RegExp(/\+?[0-9\s\-()]+/);
export const emailRegExp = new RegExp(/^$|^[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}$/);
export const onlyLettersWithNumbersRegExp = new RegExp(/^[а-яА-ЯЁё0-9\s]*$/);
export const fioRegExp = new RegExp(
  /^([А-ЯЁ][а-яё]+(-[А-ЯЁ.][а-яё.]+)?)(\s+[А-ЯЁ.][а-яё.]+(-[А-ЯЁ.][а-яё.]+)?)(\s+[А-ЯЁ.][а-яё.]+([А-ЯЁ.][а-яё.]+)?(\s+[А-ЯЁ.][а-яё.]+([А-ЯЁ.][а-яё.]+)?)?)$/i,
);
export const websiteRegExp = new RegExp(
  /^(https?:\/\/)?(www\.)?([-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_.~#?&//=]*)?)?$/,
);

export const specializationRegExp = new RegExp(/^[а-яА-ЯЁё \-,;:.]{0,255}$/);
export const authorsFioRegExp = new RegExp(/^[а-яА-ЯЁё'"«» \d()\-/.:,;0-9]+$/i);
export const lastNameRegExp = new RegExp(/^([А-ЯЁа-яё]+(-[А-ЯЁа-яё]+)?)?$/);
export const publisherTitleRegExp = new RegExp(/^[а-яА-ЯЁё'"«» ()\-/.:,;0-9]{0,255}$/);
export const addressRegExp = new RegExp(/^([А-ЯЁа-яё0-9,/.\-(); ]{0,255})$/);
export const surnameRegExp = new RegExp(/^([А-ЯЁа-яё]+(-[А-ЯЁа-яё]+)?){0,255}?$/);
export const applicationNumberRegExp = new RegExp(/^[А-Яа-яёЁ\d\-/.,]{0,15}$/i);
export const publisherPattern = new RegExp(/^[а-яА-ЯЁё'"«» \d()\-/.:,;0-9]{0,255}$/);
export const linearNameRegExp = new RegExp(/^[а-яА-ЯёЁ0-9.,:;'" ()]{0,150}$/);
export const userNameRegExp = new RegExp(/^([А-ЯЁа-яё]+(-[А-ЯЁа-яё]+)?)?$/);
export const patronymicRegExp = new RegExp(/^[А-ЯЁа-яё]*(-?[А-ЯЁа-яё]+)*$/);
export const diplomRegExp = new RegExp(/^[a-zA-Zа-яА-ЯёЁ0-9№ ]{0,15}$/);
export const educationLevelRegExp = new RegExp(/^[а-яА-ЯёЁ]{0,15}$/);
export const fioShortRegExp = new RegExp(/^([а-яА-ЯёЁ]+)\s+([а-яА-ЯёЁ]\.[а-яА-ЯёЁ]\.)$/);
